import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { graphql } from "@opensea/graphql";
import { isAddressEqual } from "@opensea/utils";
import { useEffect, useRef } from "react";
import { useClient as useUrqlClient } from "urql";
import { useAccount } from "../../polychain/hooks";
import { AccountActions } from "../accountStore";
const query = graphql(`
  query AccountStateByAddressQuery(
    $address: Address!
    $chain: ChainIdentifier
  ) {
    accountStateByAddress(address: $address, chain: $chain) {
      address
      states
    }
  }
`);
export function useLoadAccountStatesForConnectedAccount() {
  const $ = _c(7);
  const urqlClient = useUrqlClient();
  const account = useAccount();
  const currentAddressRef = useRef(undefined);
  const {
    getChainIdentifier
  } = useChains();
  let t0;
  let t1;
  if ($[0] !== account.address || $[1] !== account.chainArch || $[2] !== account.chainId || $[3] !== getChainIdentifier || $[4] !== urqlClient) {
    t0 = function loadAccountStatesForConnectedAccount() {
      currentAddressRef.current = account.address;
      const loadAccountStates = async () => {
        if (!(account.address && account.chainId)) {
          return;
        }
        const {
          data,
          error
        } = await urqlClient.query(query, {
          address: account.address,
          chain: getChainIdentifier(account.chainId, account.chainArch),
          ttl: 86400000
        });
        if (currentAddressRef.current !== account.address) {
          return;
        }
        if (error) {
          return;
        }
        if (!data?.accountStateByAddress) {
          AccountActions.setAccount(undefined);
          return;
        }
        const {
          address: responseAddress,
          states
        } = data.accountStateByAddress;
        if (!isAddressEqual(account.address, responseAddress)) {
          AccountActions.setAccount(undefined);
          return;
        }
        AccountActions.setTsStates(states);
      };
      loadAccountStates();
    };
    t1 = [urqlClient, getChainIdentifier, account.address, account.chainId, account.chainArch];
    $[0] = account.address;
    $[1] = account.chainArch;
    $[2] = account.chainId;
    $[3] = getChainIdentifier;
    $[4] = urqlClient;
    $[5] = t0;
    $[6] = t1;
  } else {
    t0 = $[5];
    t1 = $[6];
  }
  useEffect(t0, t1);
}